import { AbstractControl, FormControl } from '@angular/forms';

const ERROR_TEXT_INVALID_EXPIRY_DATE = 'Expiry date is invalid';
const ERROR_TEXT_MONTH_OUT_OF_RANGE = 'Expiry month should be between 01 and 12';
const ERROR_TEXT_YEAR_OUT_OF_RANGE = 'Expiry year cannot be in the past';



export function ValidateCCardNumber(control: AbstractControl) {

    if (control.value) {
    // remove all non digit characters

    var value = (control.value).replace(/\D/g, '');
    var sum = 0;
    var shouldDouble = false;
    // loop through values starting at the rightmost side
    for (var i = value.length - 1; i >= 0; i--) {
      var digit = parseInt(value.charAt(i));
      
      if (shouldDouble) {
        if ((digit *= 2) > 9) digit -= 9;
      }
  
      sum += digit;
      shouldDouble = !shouldDouble;
    }
    if((sum % 10) != 0){
        return { invaliCCNumber: true };
    }
 
    }
    return null;
  }

export function  ValidateIsExpiry(control: AbstractControl) {
  const EXPIRY_DATE_REGEX = /^(\d{2})\/(\d{4}|\d{2})$/;
  const MONTH_REGEX = /(0[1-9]|1[0-2])/;
    if (control.value) {
   // console.log(control.value);
    const splitDate = control.value.split('/');
    if (!EXPIRY_DATE_REGEX.test(control.value)) {
      return { isExpiryInvalid: true };
    }
    const expiryMonth = splitDate[0];
    if (!MONTH_REGEX.test(expiryMonth)) {
        return { isExpiryInvalid: true };
    }

    // const expiryYear = splitDate[1];
    // var currentYear = new Date().getFullYear();
    // currentYear = parseInt(expiryYear.length === 4 ? currentYear : currentYear.toString().substr(-2),
    //     10
    // );
    // if (currentYear > parseInt(expiryYear, 10)) {
    //     return ERROR_TEXT_YEAR_OUT_OF_RANGE;
    // }



    const expiryYear = splitDate[1];
    var currentYear = new Date().getFullYear();
   // console.log("Current Year:",currentYear +  "--Expiry Year" +  parseInt(expiryYear), currentYear > parseInt(expiryYear));
    if ((currentYear > parseInt(expiryYear))) {
       return { isExpiryInvalid: true };
    }
  }
  return null;
} 
export function ValidateUrl(control: AbstractControl) {
  if (!control.value.startsWith('https') || !control.value.includes('.io')) {
    return { invalidUrl: true };
  }
  return null;
}

export function validateAllZeros(control: FormControl) {
  if (control.value === '000' || control.value === '0000 0000 0000 0000') {
    return {
      validateAllZeros: true
    };
  }
  return null;
}

export function validateAllCCZeros(control: FormControl) {
  if (control.value === '0000000000000000000') {
    return {
      validateAllCCZeros: true
    };
  }
  return null;
}